export type DesignEditorScrollSnapshot = {
  windowLeft: number;
  windowTop: number;
  containers: Array<{
    elementIndex: number;
    left: number;
    top: number;
  }>;
  aiOverviewTop?: number;
};

const ACTIVE_TAB_SELECTOR = '.tab-content:not(.tab-content--hidden)';
const AI_OVERVIEW_RETURN_SCROLL_KEY = 'ai_overview_return_scroll_top';

const getActiveTabElements = (): HTMLElement[] => {
  const root = document.querySelector<HTMLElement>(ACTIVE_TAB_SELECTOR);

  return root ? [root, ...Array.from(root.querySelectorAll<HTMLElement>('*'))] : [];
};

const hasScrollableArea = (element: HTMLElement): boolean => (
  element.scrollHeight > element.clientHeight
  || element.scrollWidth > element.clientWidth
  || element.scrollTop !== 0
  || element.scrollLeft !== 0
);

const snapshotContainers = (elements: HTMLElement[]) => elements.flatMap((element, elementIndex) => (
  hasScrollableArea(element)
    ? [{ elementIndex, left: element.scrollLeft, top: element.scrollTop }]
    : []
));

export function captureDesignEditorScroll(): DesignEditorScrollSnapshot {
  const elements = getActiveTabElements();
  const aiOverview = document.querySelector<HTMLElement>(
    `${ACTIVE_TAB_SELECTOR} .ai-overview-panel`,
  );

  return {
    windowLeft: window.scrollX,
    windowTop: window.scrollY,
    containers: snapshotContainers(elements),
    ...(aiOverview ? { aiOverviewTop: aiOverview.scrollTop } : {}),
  };
}

const applyScrollSnapshot = (snapshot: DesignEditorScrollSnapshot) => {
  const elements = getActiveTabElements();

  window.scrollTo(snapshot.windowLeft, snapshot.windowTop);
  snapshot.containers.forEach(({ elementIndex, left, top }) => {
    const element = elements[elementIndex];

    if (element) element.scrollTo(left, top);
  });
};

export function restoreDesignEditorScroll(snapshot?: DesignEditorScrollSnapshot): void {
  if (!snapshot || !Array.isArray(snapshot.containers)) return;
  if (Number.isFinite(snapshot.aiOverviewTop)) {
    window.sessionStorage.setItem(AI_OVERVIEW_RETURN_SCROLL_KEY, String(snapshot.aiOverviewTop));
  }
  globalThis.requestAnimationFrame(() => {
    globalThis.requestAnimationFrame(() => applyScrollSnapshot(snapshot));
  });
}
